export const ACTIVE_PRODUCT = 1
export const DISCONTINUED_PRODUCT = 2

export const LIST_TABS = [
  {
    id: ACTIVE_PRODUCT,
    label: 'IActiveProduct',
  },
  {
    id: DISCONTINUED_PRODUCT,
    label: 'IDiscontinuedProducts',
  },
]

export const ANALYSIS_NUMBER_LIST = [
  {
    id: 0,
    title: 'IPremiumSummaryV2',
    case: 50,
    total: 50,
    Payment: 50,
    Recharge: 0,
    Use: 0,
  },
  {
    id: 1,
    title: 'IHRVSummaryAdvanced',
    case: 63,
    total: 61,
    Payment: 53,
    Recharge: 10,
    Use: 2,
  },
]

export const KEY_TABLE_LOGS = {
  USAGE_DATE_TIME: 'usageDateTime',
  METHOD: 'method',
  USAGE_QUANTITY: 'usageQuantity',
  DETAIL: 'detail',
  MANUAL_PAYMENT: 'manualPayment',
  RECHARGE_CURRENT_MONTH: 'rechargeCurrentMonth',
  RECHARGE_CARRYOVER: 'rechargeCarryover',
  USE: 'use',
  REASON: 'reason',
  USAGE_ID: 'usageId',
  OFFER_BY: 'offerBy',
  index: 'index',
}

export const BULK_TABLE_COLUMN = [
  {
    id: 0,
    label: 'ItherapyId',
    key: KEY_TABLE_LOGS.index,
  },
  {
    id: 1,
    label: 'IDateV1',
    key: KEY_TABLE_LOGS.USAGE_DATE_TIME,
  },
  {
    id: 2,
    label: 'IDivision',
    key: KEY_TABLE_LOGS.METHOD,
  },
  {
    id: 3,
    label: 'IAnalysisNumber',
    key: KEY_TABLE_LOGS.USAGE_ID,
  },
  {
    id: 4,
    label: 'IRemark',
    key: KEY_TABLE_LOGS.REASON,
  },
]

export const MONTHLY_TABLE_COLUMN = [
  {
    id: 0,
    label: 'ItherapyId',
    key: KEY_TABLE_LOGS.index,
  },
  {
    id: 1,
    label: 'IDateV1',
    key: KEY_TABLE_LOGS.USAGE_DATE_TIME,
  },
  {
    id: 2,
    label: 'IDivision',
    key: KEY_TABLE_LOGS.METHOD,
  },
  {
    id: 3,
    label: 'IAnalysisNumber',
    key: KEY_TABLE_LOGS.USAGE_ID,
  },
  {
    id: 4,
    label: 'IDetailV1',
    key: KEY_TABLE_LOGS.DETAIL,
  },
  {
    id: 5,
    label: 'IPaymentV1',
    key: KEY_TABLE_LOGS.MANUAL_PAYMENT,
  },
  {
    id: 6,
    label: 'IChargeV1',
    key: KEY_TABLE_LOGS.RECHARGE_CURRENT_MONTH,
  },
  {
    id: 7,
    label: 'IChargeCarryover',
    key: KEY_TABLE_LOGS.RECHARGE_CARRYOVER,
  },
  {
    id: 8,
    label: 'IDurationV1',
    key: KEY_TABLE_LOGS.USE,
  },
  {
    id: 9,
    label: 'IRemark',
    key: KEY_TABLE_LOGS.REASON,
  },
]

export const MONTHLY_PAYMENT_COLUMN = [
  {
    id: 0,
    label: 'IPeriod',
    key: 'period',
  },
  {
    id: 1,
    label: 'IDivision',
    key: 'cls',
  },
  {
    id: 2,
    label: 'IAnalysisIndicatorsV1',
    key: 'AnalysisIndicators',
  },
  {
    id: 3,
    label: 'IMonthlyPayment',
    key: 'offerQuantity',
  },
  {
    id: 4,
    label: 'IManualPayment',
    key: 'manualPayment',
  },
  {
    id: 5,
    label: 'IRechargeCurrentMonth',
    key: 'rechargeCurrentMonth',
  },
  {
    id: 6,
    label: 'IRechargeCarryover',
    key: 'rechargeCarryover',
  },
  {
    id: 7,
    label: 'IUse',
    key: 'use',
  },
  {
    id: 8,
    label: 'ILeftOver',
    key: 'leftover',
  },
]

export const BULK_PAYMENT_COLUMN = [
  {
    id: 0,
    label: 'IPeriod',
    key: 'period',
  },
  {
    id: 1,
    label: 'IDivision',
    key: 'cls',
  },
  {
    id: 2,
    label: 'IAnalysisIndicatorsV1',
    key: 'AnalysisIndicators',
  },
  {
    id: 3,
    label: 'IUse',
    key: 'use',
  },
  {
    id: 4,
    label: 'IRemark',
    key: 'Notes',
  },
]

export const MANUAL_PAYMENT_COLUMN = [
  {
    id: 0,
    label: 'ItherapyId',
    key: KEY_TABLE_LOGS.index,
  },
  {
    id: 1,
    label: 'IRemark',
    key: KEY_TABLE_LOGS.REASON,
  },
  {
    id: 2,
    label: 'IDivision',
    key: KEY_TABLE_LOGS.METHOD,
  },
  {
    id: 3,
    label: 'IAnalysisNumber',
    key: KEY_TABLE_LOGS.USAGE_ID,
  },
  {
    id: 4,
    label: 'IDetailV1',
    key: KEY_TABLE_LOGS.DETAIL,
  },
  {
    id: 5,
    label: 'IPaymentV1',
    key: KEY_TABLE_LOGS.MANUAL_PAYMENT,
  },
  {
    id: 6,
    label: 'IChargeV1',
    key: KEY_TABLE_LOGS.RECHARGE_CURRENT_MONTH,
  },
  {
    id: 7,
    label: 'IDurationV1',
    key: KEY_TABLE_LOGS.USE,
  },
  {
    id: 8,
    label: 'IDateV1',
    key: KEY_TABLE_LOGS.USAGE_DATE_TIME,
  },
]

export const METHOD_LOGS = {
  MANUAL: 'IManualPayment',
  PAYMENT_GOODS: 'IProductsOrder',
  PAYMENT_CHARGE: 'IPay',
}
